import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  border-bottom: 2px solid black;
  padding-bottom: 15px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  border-bottom: 1px solid #eee;
  align-items: center;

  > h3 {
    margin-top: 0;
    font-weight: 600;
    padding-bottom: 13px;
    font-size: 14px;
    margin-bottom: 0;
    color: ${COLORS.BODY_TEXT};
  }
  > button {
    color: ${COLORS.BLACK};
  }
`;

const AddedProduct = styled.div`
  flex-direction: row;
  margin: 15px 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  > div {
    padding-right: 20px;
  }
  @media (max-width: 1057px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 652px) {
    grid-template-columns: repeat(2, 1fr);
    > div {
      padding-right: 10px;
    }
  }
  @media (max-width: 478px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Update = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  > button {
    background-color: ${COLORS.BLACK};
    font-size: 14px;
    border-radius: 3px;
    padding: 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    :hover {
      opacity: 0.8;
      background-color: ${COLORS.BLACK};
      color: ${COLORS.WHITE};
    }
  }
`;

const EUFieldWrapper = styled.div`
  display: grid;
  gap: 20px;
`;

export { Heading, AddedProduct, Container, Update, EUFieldWrapper };
